import { render, staticRenderFns } from "./StaffUsersList.vue?vue&type=template&id=3f901ef4"
import script from "./StaffUsersList.vue?vue&type=script&lang=js"
export * from "./StaffUsersList.vue?vue&type=script&lang=js"
import style0 from "./StaffUsersList.vue?vue&type=style&index=0&id=3f901ef4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports